<template>
  <div class="frame c-footer">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="c-footer__container">
            <p>
              © Kingspan Group
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
